module.exports = __webpack_public_path__ + "img/img6.0d8a27e8.jpg";